import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveillancesRoutingModule } from './surveillances-routing.module';
import { SurveillancesLandingComponent } from './surveillances-landing/surveillances-landing.component';
import { SurveillancesLinkComponent } from './surveillances-link/surveillances-link.component';
import { SurveillancesComponent } from './surveillances/surveillances.component';
import { AddemployeeComponent } from './addemployee/addemployee.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AgGridModule } from 'ag-grid-angular';
import { BuildinglistComponent } from './buildinglist/buildinglist.component';



@NgModule({
  declarations: [
    SurveillancesLandingComponent,
    SurveillancesLinkComponent,
    SurveillancesComponent,
    AddemployeeComponent,
    BuildinglistComponent
  ],
  imports: [
    CommonModule,
    SurveillancesRoutingModule,
    AcademicFormModule,
    DragDropModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatInputModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatDividerModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    NgxSpinnerModule,
  ]
})
export class SurveillancesModule { }
